<template>
    <button-block
        without-loading
        @completed="$router.push({ name: 'brand-create' }); $event.button.setState('content')"
    >
        <svg-icon :icon="AddIcon" />
        <span v-text="t('createButton')" />
    </button-block>
</template>

<script setup lang="ts">
    import AddIcon from '@keyvue/one-material-icons/icons/add.svg?component';
    import { useI18n } from 'vue-i18n';
    import messages from './AddBrandButton.messages.json';

    const { t } = useI18n({ messages });
</script>
